// Import necessary dependencies
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from './styles/GlobalStyles';
import theme from './styles/theme';

// Import components
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import Story from './components/Story/Story';
import Portfolio from './components/Portfolio/Portfolio';
import Projects from './components/Projects/Projects';
import Contact from './components/Contact/Contact';
import BackToTop from './components/BackToTop/BackToTop';
import ParticleSystem from './components/ParticleSystem/ParticleSystem';

// Main App component
const App: React.FC = () => {
  return (
    // ThemeProvider makes the theme available to all styled components
    <ThemeProvider theme={theme}>
      {/* GlobalStyles applies base styles to the entire app */}
      <GlobalStyles />

      {/* Interactive particle background */}
      <ParticleSystem />

      {/* Main navigation */}
      <Header />

      {/* Home section */}
      <Home />

      {/* Portfolio section */}
      <Portfolio />

      {/* Story section */}
      <Story />

      {/* Projects section */}
      {/* <Projects /> */}

      {/* Contact form */}
      <Contact />

      {/* Scroll-to-top button */}
      <BackToTop />
    </ThemeProvider>
  );
};

export default App;
